<template>
<div><AboutUsNav></AboutUsNav>
  <div class="aboutwes">
    <!-- <a class="aaaaaa" href="/aboutwe#a" style="font-size: 24px"><div>aaaaaa</div></a> -->
    <div class="aboutwe">

      <div class="aboutwe_container1">
        <h3 id='b'>企业文化</h3>
        <div class="about-line2"></div>

        <div class="about-con">
          <img
            id="aa1"
            src="@/assets/images/About_1.png"
            alt=""
          >
          <img
            id="aa2"
            src="@/assets/images/About_2.png"
            alt=""
          >
          <img
            id="aa3"
            src="@/assets/images/About_3.png"
            alt=""
          >
          <img
            id="aa4"
            src="@/assets/images/About_4.png"
            alt=""
          >
          <img
            id="aa5"
            src="@/assets/images/About_Two.jpg"
            alt=""
          >

        </div>

        <div class="ct">
          <p class="p1t">企业使命</p>
          <p class="p1c">--帮助企业将废旧设备快速变现</p>
          <p class="p1x"></p>
        </div>
        <div class="ct">
          <p class="p2t">企业前景</p>
          <p class="p2c">--打造中国互联网拍卖第一专业服务平台</p>
          <p class="p2x"></p>
        </div>
        <div class="ct">
          <p class="p3t">核心价值观</p>
          <p class="p3c">--我们一直为客户的效果而努力</p>
          <p class="p3x"></p>
        </div>
        <div class="ct">
          <p class="p4t">企业理念</p>
          <p class="p4c">--真心真意做人 一心一意做事 全心全意服务</p>
          <p class="p4x"></p>
        </div>
      </div>

    </div>
  </div>
</div>
</template>

<script>
// import { formatDate } from '@/assets/js/date.js'
import AboutUsNav from '@/components/AboutUsNav.vue';
export default {
  metaInfo: {
    title: "拍界——唤醒您的沉睡资产",
    meta: [{
      name: "keywords",
      content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }, {
      name: "description",
      content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }]
  },
  data () {
    return {
      subjects: [],
      //分页器
      paginator: {
        first: null,
        before: null,
        previous: null,
        current: 1,
        last: null,
        next: null,
        total_pages: null,
        total_items: null,
        limit: 20,
      },
    }
  },

  created () {
    // 显示公共栏
    this.$emit('header', true)
    this.$emit('footer', true)

    // 加载路由参数
    this.getRouteQuery()
    // 请求列表数据
    this.getSubjects()

    // 页面至顶部
    window.scrollTo(0, 0);
  },
  components: {
    AboutUsNav
  }


}
</script>